export const setQueryParameter = (url, key, value) => {
  if (!url) return ""

  try {
    const urlObj = new URL(url)

    urlObj.searchParams.set(key, value)

    return urlObj.toString()
  } catch (e) {
    return url
  }
}
